/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Mode_AskInputs */



/**
* | output |
* | --- |
* | "Ask" |
*
* @param {Assistant_Mode_AskInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_mode_ask = /** @type {((inputs?: Assistant_Mode_AskInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Mode_AskInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demander")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fragen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiedere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Просить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preguntar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("问")
	if (locale === "ja") return /** @type {LocalizedString} */ ("聞く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूछना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Perguntar")
	return /** @type {LocalizedString} */ ("Ask")
});